<template>
  <div>
    <!------------ start toast / snackbar ------------------------------>
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="snackbar"
      :timeout="timeout"
      color="primary"
      outlined
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="primary" size="22"
            >mdi-checkbox-multiple-marked-circle-outline</v-icon
          >
          <span class="mt-n1 ml-5 text_style">Update successfully</span>
        </div>
        <div>
          <v-icon color="primary" size="22" @click="snackbarClose()"
            >mdi-close-circle-outline</v-icon
          >
        </div>
      </div>
    </v-snackbar>
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="Deletesnackbar"
      :timeout="timeout"
      color="error"
      outlined
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="error" size="22">mdi-alert-circle-outline</v-icon>
          <span class="mt-n1 ml-5 text_style">Delete successfully</span>
        </div>
        <div>
          <v-icon color="error" size="22" @click="snackbarClose()"
            >mdi-close-circle-outline</v-icon
          >
        </div>
      </div>
    </v-snackbar>
    <!-- <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" /> -->
    <!------------ end toast / snackbar ------------------------------>
    <!------------ section one ------------------------------>
    <v-row class="d-flex justify-space-between" flat>
      <v-col md="6" sm="6">
        <h1 class="heading-1">Admin Roles</h1>
      </v-col>
      <!--------------------------- add team --------------------------------------->
      <v-col md="6" sm="6">
        <v-card flat class="d-flex justify-end mt-2">
          <!-- <v-btn color="primary">Add new</v-btn> -->
          <v-btn
            color="primary"
            dark
            class="text_style px-7"
            depressed
            @click="OpenAddDialog()"
          >
            Add new
          </v-btn>
          <v-dialog v-model="add_dialog" v-if="add_dialog" max-width="900">
            <v-card>
              <div
                class="mx-10 py-8 d-flex justify-space-between"
                color="#F6F8FC"
              >
                <span class="heading-2"> <b>Add Admin Roles</b></span>
                <v-icon @click="add_dialog = false">mdi-close</v-icon>
              </div>

              <v-card color="#F6F8FC" flat>
                <div class="mx-5">
                  <adminrole-component
                    :Item="Item"
                    :Editdialog="Editdialog"
                    :SetItem="SetEditItem"
                    :Type="Type"
                    @SetName="SetName"
                  />
                </div>
              </v-card>

              <v-card-actions class="pb-8 mx-5">
                <v-spacer></v-spacer>
                <div class="AddTeamFotterBtnDestop">
                  <v-btn
                    color="red darken-1"
                    text
                    @click="CloseAddModel"
                    class="mx-4"
                  >
                    <span class="text_style"> Cancel </span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    depressed
                    class="px-11"
                    @click="SaveChanges()"
                  >
                    <span class="text_style" v-if="!Saving">Save</span>

                    <v-progress-circular
                      indeterminate
                      v-else
                      size="20"
                      class="px-5"
                      color="white"
                    ></v-progress-circular>
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>

    <!------------------- data table ---------------------------------->
    <div>
      <v-card class="mt-6" outlined flat>
        <v-data-table
          :headers="headers"
          :page.sync="page"
          :hide-default-footer="true"
          :items="TeamDataTableOne"
          :loading="tableLoader"
          disable-pagination
          :items-per-page-text="itemsPerPage"
          sort-by=""
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.Id`]="{ index }">
            <span class="index_h1_text_style">
              <b> {{ index + 1 }} </b>
            </span>
          </template>
          <template v-slot:[`item.Name`]="{ item }">
            <span class="index_span_2_style"> {{ item.Name }} </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
              v-if="item.Name != 'Master'"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card style="border-radius: 1vw" flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="OpenViewDialog(item)"
                  >
                    <v-icon color="#646464">mdi-eye</v-icon>
                    <span class="ml-4 text_style action_dialog">View</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="OpenEditDialog(item)"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style action_dialog">Edit</span>
                  </v-btn>
                </v-list>

                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="Delete(item)"
                  >
                    <v-icon color="#646464">mdi-delete</v-icon>
                    <span class="ml-4 text_style">Delete</span>
                  </v-btn>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
            @change="fetchData()"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
          @input="fetchData()"
        ></v-pagination
      ></v-card>
    </div>
    <v-dialog v-model="Viewdialog" v-if="Viewdialog" max-width="900">
      <v-card>
        <div class="mx-5 py-8 d-flex justify-space-between" color="#F6F8FC">
          <span class="heading-2"> <b> View Admin Roles</b></span>
          <v-icon @click="Viewdialog = false">mdi-close</v-icon>
        </div>
        <v-card color="#F6F8FC" flat>
          <adminrole-component
            :Item="SelectedItem"
            :Editdialog="Editdialog"
            :SetItem="SetEditItem"
            @SetName="SetName"
            :Type="Type"
          />
        </v-card>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="Viewdialog = false"
            class="mx-4"
          >
            <span class="text_style"> Cancel </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="Editdialog" v-if="Editdialog" max-width="900">
      <v-card>
        <div class="mx-5 py-8 d-flex justify-space-between" color="#F6F8FC">
          <span class="heading-2"> <b> Edit Admin Roles</b></span>
          <v-icon @click="Editdialog = false">mdi-close</v-icon>
        </div>
        <v-card color="#F6F8FC" flat class="mb-4">
          <adminrole-component
            :Item="Item"
            :Editdialog="Editdialog"
            :SetItem="SetEditItem"
            :Type="Type"
            @SetName="SetName"
          />
        </v-card>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="CloseEditModel" class="mx-4">
            <span class="text_style"> Cancel </span>
          </v-btn>
          <v-btn color="primary" depressed class="px-11" @click="EditRoles()">
            <span class="text_style" v-if="!Saving">Save</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Start Delete Modal -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" text @click="ConfirmDelete">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AdminroleComponent from "../../components/Roles/adminrole.component.vue";
//import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
//import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
// import Swal from "sweetalert2";
import { mapGetters } from "vuex";
export default {
  components: {
    //SuccessToastComponent,
    //ErrorToastComponent,
    AdminroleComponent,
  },
  computed: {
    ...mapGetters([
      "GetRoles",
      "GetDefaultRolesPermissions",
      "GetUserRolePermissions",
    ]),
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      snackbar: false,
      Deletesnackbar: false,
      Viewdialog: false,
      Editdialog: false,
      Readswitch: true,
      Updateswitch: true,
      Createswitch: true,
      dialog: false,
      ErrorToast: false,
      SuccessToast: false,
      add_dialog: false,
      btnloader: false,
      close: "",
      Saving: false,
      Read: false,
      search: "",
      tableLoader: false, // data-table true or false
      headers: [
        { text: "#", value: "Id", sortable: false },
        { text: "Role Name", value: "Name", sortable: true },

        { text: "", value: "actions", sortable: false },
      ],
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      TeamDataTableOne: [],
      SelectedItem: null,
      Item: null,
      Type: "Add",
      timeout: 1500,
      deleteObj: {},
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    snackbarClose() {
      // this.snackbar = false;
      this.Deletesnackbar = false;
    },
    Delete(item) {
      this.dialog = true;
      this.deleteObj.id = item.Id;
      this.deleteObj.name = item.Name;
    },
    ConfirmDelete() {
      var form = new FormData();
      form.append("id", this.deleteObj.id);
      form.append("name", this.deleteObj.name);
      this.$store.dispatch("DeleteRole", form).then((res) => {
        this.dialog = false;
        this.deleteObj = {};
        if (res.Status) {
          this.$swal.fire({
            icon: "success",
            title: res.Message,
          });
          this.fetchData();
        } else {
          this.$swal.fire({
            icon: "error",
            title: res.Message,
          });
        }
      });
    },
    SaveChanges() {
      this.Saving = true;

      if (this.Item.Name == "") {
        this.$swal.fire({
          icon: "warning",
          title: '<span style="font-size:20px"> Role name is required</span>',
          confirmButtonColor: "#3085d6",
          showConfirmButton: true,
        });
        this.Saving = false;
      } else if (
        this.Item.RolePermissions.some((x) => x.View == true) == false
      ) {
        this.$swal.fire({
          icon: "warning",
          title:
            '<span style="font-size:20px"> Altest one permission is required</span>',
          confirmButtonColor: "#3085d6",
          showConfirmButton: true,
        });
        this.Saving = false;
      } else {
        this.$store
          .dispatch("SaveRoles", this.Item)
          .then(() => {
            this.Saving = false;
            this.CloseEditModel();
            this.CloseViewModel();
            this.CloseAddModel();
            this.fetchData();
            this.snackbar = true;
            this.add_dialog = false;
            this.$store.dispatch(
              "GetRolePermissions",
              this.GetUserRolePermissions.Id
            );
          })
          .catch(() => {
            this.$swal.fire({
              icon: "warning",
              title: '<span style="font-size:20px"> Role already exist</span>',
              confirmButtonColor: "#3085d6",
              showConfirmButton: true,
            });
          });
      }
    },
    EditRoles() {
      this.Saving = true;
      if (this.Item.Name == "") {
        this.$swal.fire({
          icon: "warning",
          title: '<span style="font-size:20px"> Role name is required</span>',
          confirmButtonColor: "#3085d6",
          showConfirmButton: true,
        });
        this.Saving = false;
      } else if (
        this.Item.RolePermissions.some((x) => x.View == true) == false
      ) {
        this.$swal.fire({
          icon: "warning",
          title:
            '<span style="font-size:20px"> Altest one permission is required</span>',
          confirmButtonColor: "#3085d6",
          showConfirmButton: true,
        });
        this.Saving = false;
      } else {
        this.$store
          .dispatch("EditRoles", this.Item)
          .then(() => {
            this.Saving = false;
            this.CloseEditModel();
            this.CloseViewModel();
            this.CloseAddModel();
            this.fetchData();
            this.snackbar = true;
            this.add_dialog = false;
            this.$store.dispatch(
              "GetRolePermissions",
              this.GetUserRolePermissions.Id
            );
          })
          .catch(() => {
            this.$swal.fire({
              icon: "warning",
              title: '<span style="font-size:20px"> Role already exist</span>',
              confirmButtonColor: "#3085d6",
              showConfirmButton: true,
            });
          });
      }
    },
    SetEditItem(V) {
      this.EditItem = V.RolePermissions.map((e) => {
        if (!e.View) {
          e.Add = false;
          e.Delete = false;
          e.Edit = false;
        }
        return e;
      });
    },
    SetName(name) {
      this.Item.Name = name;
    },
    CloseEditModel() {
      this.Editdialog = false;
    },
    CloseAddModel() {
      this.add_dialog = false;
    },
    CloseViewModel() {
      this.Viewdialog = false;
    },
    OpenAddDialog() {
      this.Type = "Add";
      this.add_dialog = true;
      this.$store.dispatch("GetDefaultRolePermissions").then(() => {
        this.Item = {
          Id: 0,
          Name: "",
          RolePermissions: this.GetDefaultRolesPermissions,
        };
      });
    },
    OpenEditDialog(item) {
      this.fetchData();

      this.Type = "Edit";
      this.Item = item;
      this.Editdialog = true;
    },
    OpenViewDialog(item) {
      this.SelectedItem = item;
      this.Viewdialog = true;
      this.Type = "Read";
    },
    openadddialog() {
      this.add_dialog = true;
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        (this.add_dialog = false),
          (this.btnloader = false),
          (this.SuccessToast = true);
      }, 2000);
      setTimeout(() => {
        this.SuccessToast = false;
      }, 3000);
    },

    DdialogClose() {
      this.dialog = false;
      this.ErrorToast = true;
      setTimeout(() => {
        this.ErrorToast = false;
      }, 1500);
    },

    fetchData() {
      this.TeamDataTableOne = [];
      var obj = {
        page: this.page,
        pageSize: this.itemsPerPage,
      };
      this.tableLoader = true;
      this.$store.dispatch("GetRoles", obj).then((res) => {
        // var sa = this.GetRoles.find((x) => x.Name.startsWith("SuperAdmin"));

        // var nsa = this.GetRoles.filter((x) => x.Name !== "SuperAdmin").sort(
        //   function (a, b) {
        //     if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
        //       return -1;
        //     }
        //     if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
        //       return 1;
        //     }
        //     return 0;
        //   }
        // );
        var nsa = this.GetRoles.sort(function (a, b) {
          if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
            return -1;
          }
          if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
            return 1;
          }
          return 0;
        });
        this.TeamDataTableOne = [...this.TeamDataTableOne, ...nsa];

        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.totalRecords / this.itemsPerPage);
          if (res.page > this.pageCount) {
            console.log("wewqe");
          } else {
            this.page = res.page;
          }
        } else {
          this.pageCount = 1;
        }

        this.tableLoader = false;
      });
    },
  },
};
</script>